/* eslint-disable react/prop-types */
/**
 * OrdersProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import OrdersContext from './orders-context'
import {
  fetchOrders,
  fetchOrder,
  fetchOrderByReferenceNumber,
  fetchOrderByUuid,
  updateOrder,
  updateOrderToDecline
} from './orders-api'

export default function OrdersProvider({ children }) {
  const state = {
    fetchOrders,
    fetchOrder,
    fetchOrderByReferenceNumber,
    fetchOrderByUuid,
    updateOrder,
    updateOrderToDecline
  }
  return (
    <OrdersContext.Provider value={state}>
      {children}
    </OrdersContext.Provider>
  )
}
